import Svg from "../Helper/Svg";
import translate from "../../Utils/translate";

export default function SideBarOptions({ active, disabled, icon, text }) {
  const activeClass = active ? "text-theme-accent bg-theme-secondary" : "";
  const disabledClass = disabled ? "opacity-70 cursor-not-allowed" : "cursor-pointer hover:bg-theme-primary-hover";

  return (
    <li
      className={`flex w-full p-default rounded-default ${activeClass} ${disabledClass}`}
      title={disabled && translate("pages.nav.coming_soon")}
    >
      <Svg active={active} className="mr-default" icon={icon} />
      <span>{text}</span>
    </li>
  );
}
